import { useMemo } from 'react';
import { DashBoardValue } from 'features/dashBoard/hooks'
import { DashBoardItemOption } from 'features/dashBoard/types'
import { getAxisDef, getValueDef, GraphOptions } from '../../common'
import { TargetListResult } from "interface/search/targetList"

export const FunnelGraphOptions: GraphOptions[][] = [
  [
    {
      id: 'axis',
      type: 'rank',
      label: 'ランク',
      suffix: 'ごとの'
    },
    {
      id: 'value',
      type: 'value',
      label: '値'
    },
    {
      id: 'inverse',
      type: 'check',
      label: '逆順',
      default: 'false'
    }
  ]
]

type useFunnelGraphOptionProps<T> = {
  options?: DashBoardItemOption[]
  dashBoard: DashBoardValue<T>
  targetList?: TargetListResult
}
export const useFunnelGraphOption = <T,>({
  options,
  dashBoard: {
    configure,
		globalAxisKey
  },
  targetList
}: useFunnelGraphOptionProps<T>) => useMemo(
  () => ({
    configure, targetList,
		axisDef: getAxisDef(configure, options, 'axis', globalAxisKey, targetList),
		valueDef: getValueDef(configure, options, 'value', targetList),
    inverse: options?.find((opt) => opt.id === 'inverse')?.value === 'true'
  }),
  [configure, options, globalAxisKey, targetList]
)
